import * as React from 'react'
import styled from 'styled-components'

import * as plume from '@ulule/owl-kit-components/next'
import * as hooks from '@owl-nest/hooks'

import { useGiftIdeaListing, HITS_PER_PAGE } from './hooks/useGiftIdeaListing'
import * as results from '../components/Results'

export function Results(): React.ReactElement {
  const { response } = useGiftIdeaListing()

  const data = hooks.data(response)
  const lengthRef = React.useRef(data?.hits.length)

  if (data === undefined) {
    return <results.ResultsSkeleton length={lengthRef.current ?? HITS_PER_PAGE} />
  }

  if (response.status === hooks.QueryStatus.FAILURE) return <></>

  if (data.nbHits === 0) {
    lengthRef.current = 3
    return <results.EmptyResults />
  } else {
    lengthRef.current = data.hits.length
  }

  return <FullGridResults products={data.hits} onProductClick={(product) => trackProduct(product.objectID)} />
}

const FullGridResults = styled(results.Results)`
  && {
    @media screen and ${plume.BREAKPOINTS.TABLET} {
      grid-template-columns: repeat(2, 1fr);
    }

    @media screen and ${plume.BREAKPOINTS.LAPTOP} {
      grid-template-columns: repeat(3, 1fr);
    }

    @media screen and (min-width: 1240px) {
      grid-template-columns: repeat(4, 1fr);
    }
  }
`

const SESSION_STORAGE_KEY = 'bob_gift_ideas_products'

function trackProduct(productId: string) {
  const rawValue = localStorage.getItem(SESSION_STORAGE_KEY)

  if (!rawValue) {
    localStorage.setItem(SESSION_STORAGE_KEY, JSON.stringify([productId]))
    return
  }

  const trackedProducts = JSON.parse(rawValue) as string[]
  if (!trackedProducts.includes(productId)) {
    trackedProducts.push(productId)
    localStorage.setItem(SESSION_STORAGE_KEY, JSON.stringify(trackedProducts))
  }
}
